import { Box, Card, Typography, Button } from "@mui/material";
import WalletIcon from "@mui/icons-material/AccountBalanceWallet"; // You can replace with custom SVG
import RupeeCoinGift from "../../assets/RupeeCoinGif (1).gif"
export default function CashbackCard({orderId,handleOrderNow,CashBackvalue}) {
  return (
    <>
    
          <Typography
        variant="subtitle2"
        sx={{
          color: "brown",
          fontWeight: 600,
          display: "flex",
          alignItems: "center",
          mb: 1,
          mt:3
        }}
      >
        Active On This Order {" "}✨
      </Typography>
   
    <Card
      elevation={0}
      sx={{
        p: 2.5,
        borderRadius: "16px",
        border: "1.5px solid #A3E5C5",
        background: "linear-gradient(90deg, #E8FFE9 0%, #FFFBD5 100%)",
      }}
    >
  

      {/* Order ID */}
  

      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        {/* Wallet Icon */}
               <img src={ RupeeCoinGift} style={{    marginTop: "-81px",    justifyContent: "space-between",    width: "70px",
    position: "relative",
    top: "80px"}}/>


        {/* Cashback text + amount */}
        <Box sx={{ textAlign: "right",width:"70%" }}>
            <div style={{display:"flex",    "justify-content": "space-between",
    "align-items": "flex-end"}}>

<div>
                    <Typography
        sx={{
          fontSize: "12px",
          color: "#AA5B19",
          textAlign: "start",
          mb: 1,
        }}
      >
        Order ID: {orderId}
      </Typography>
          
          <Typography
            sx={{
              fontWeight: 500,
              fontSize: "20px",
             color: "#AA5B19",
              lineHeight: 1,
              textAlign:"start"
            }}
          >
            Cashback Won
          </Typography>


          </div>
          
       <Typography
            sx={{
              fontWeight: 700,
              fontSize: "23px",
              color: "#0A8A54",
              position:"relative",
              top:"10px"
            }}
          >
            ₹ {CashBackvalue}
          </Typography>
            </div>
   
        </Box>
      </Box>

      {/* Order Now button */}
      <Box textAlign="end" mt={2}>
        <Button
        onClick={(e)=>{handleOrderNow()}}
          variant="outlined"
          sx={{
            background:"white",
            width:"70%",
            borderRadius: "12px",
            px: 4,
            py: 1,
            borderColor: "#0A8A54",
            color: "#00B177",
            fontWeight: 700,
            fontSize: "18px",
            boxShadow: "0px 2px 6px rgba(0,0,0,0.15)",
            textTransform: "none",
            "&:hover": {
              borderColor: "#0A8A54",
              backgroundColor: "#E9FFF0",
            },
          }}
        >
          Order Now
        </Button>
      </Box>
    </Card>

     </>
  );
}
